exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "body{text-rendering:optimizeLegibility;background-color:palette(#fff);margin:0}#app{width:100vw;font-family:Avenir,Lato,sans-serif;font-size:.9rem;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.text-center{text-align:center}@font-face{font-family:Adobe Caslon Pro;src:url(" + require("./assets/font/adobe_caslon_pro.woff") + ") format(\"woff\")}@font-face{font-family:Aktiv Grotesk Corp;src:url(" + require("./assets/font/aktivgrotesk-corp-regular.woff") + ") format(\"woff\")}@font-face{font-family:Aktiv Grotesk Corp Bold;src:url(" + require("./assets/font/aktivgrotesk-corp-bold.woff") + ") format(\"woff\")}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-69df707e!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 940
// module chunks = 0